import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // Responsive CSS

import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5"; // Responsive JS
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons/js/buttons.colVis.min.js";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import "../VendorLeads/VendorLeadDataTableCSS.css";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import NotifyMessageNoReload from "../../../Others/NotifyMessageNoReload";
import { useAuth } from "../../../../Store/AuthContext";
import APIDataFetchLoader from "../../../Others/APIDataFetchLoader";

DataTable.use(DT);

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function NewsPaperendorDataTable() {
  const { userID, RendomTokenfetch, vendorRollID } = useAuth();
  const navigate = useNavigate();
  const [NewsPaperVendor, setNewsPaperVendor] = useState([]);
  const [StatusNewsCount, setStatusNewsCount] = useState([]);

  const vendorworkstatus = [
    { id: "1", title: "Publish" },
    { id: "0", title: "UnPublish" },
  ];

  const vendorRequeststatus = [
    { id: "0", title: "Reject" },
    { id: "1", title: "Accept" },
    { id: "2", title: "Pending" },
  ];

  const [Filterloading, setFilterloading] = useState(false);
  const tableRef = useRef(null);

  const [vendorStatus, setvendorStatus] = useState([]);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    workStatus: "",
    Requeststatus: "",
    vendorWorkstatus: "",
  });
  const filtersRef = useRef(filters);

  const [loading, setLoading] = useState(false);

  // *********Fetch Vendor Status on component mount********
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("vendor_role", vendorRollID);
    const FetchVendorStatusData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}newspaperFilterStatus`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setvendorStatus(response.data.statusdata || []);
            }
            if (response.data.Status === "0") {
              setvendorStatus([]);
            }
          });
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorStatusData();
  }, [RendomTokenfetch, userID, vendorRollID]);

  // console.log(NewsPaperVendor);
  const [tempFilters, setTempFilters] = useState(filters);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setTempFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    filtersRef.current = filters;
    const tableInstance = tableRef.current?.dt();
    if (tableInstance) {
      setFilterloading(true); // Show loader
      // console.log("Reloading with filters:", filtersRef.current);

      tableInstance.ajax.reload(() => {
        setFilterloading(false); // Hide loader after reload finishes
      });
    }
  }, [filters]);

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setFilters(tempFilters); // triggers reload through useEffect
  };

  const handleCountBoxClick = (key, value) => {
    const updatedFilters = {
      ...filters,
      vendorWorkstatus: "", // reset this by default
      Requeststatus: "", // reset this by default
      workStatus: "", // reset this by default
    };

    updatedFilters[key] = value;

    setTempFilters(updatedFilters); // Update temporary state
    setFilters(updatedFilters); // Trigger useEffect to reload table
  };

  const newspaperClearFilter = () => {
    const clearedFilters = {
      startDate: "",
      endDate: "",
      workStatus: "",
      Requeststatus: "",
      vendorWorkstatus: "",
    };
    setTempFilters(clearedFilters);
    setFilters(clearedFilters); // useEffect will handle reload
  };

  // *********** DataTable Coulmns *********
  const columns = [
    {
      title: `<input type="checkbox" id="selectAll" name="allrowCheckStaus"/>`, // Header checkbox
      data: null,
      orderable: false,
      searchable: false,
      render: (data, type, row) => {
        return `<input type="checkbox" id="rowcheck${row.id}" name="rowcheckStatuschange" class="row-checkbox" data-id="${row.id}" />`;
      },
    },

    {
      title: "Ticket",
      data: "ticket",
    },
    {
      title: "News Paper Name",
      data: "news_paper_name",
    },
    {
      title: "Quotation",
      data: "coutation",
    },
    {
      title: "Status",
      data: "status",
      render: (data, type, row) => {
        return `<span class="badge" style="color:${row.status_color};background-color:${row.status_bgcolor};">${data}</span>`;
      },
    },
    { title: "Schedule Date", data: "shedule_date" },
    // { title: "Publish Status", data: "publish_status" },
    { title: "Date", data: "date" },

    {
      title: "Request Status",
      data: "vender_status",
      render: (data, type, row) => {
        let requSts = "";
        if (data === "1") {
          requSts = `<span class="badge bg-success">
                                  Approve
                                </span>`;
        } else if (data === "2") {
          requSts = `<span class="badge bg-warning">
                                  Pending
                                </span>`;
        } else {
          requSts = `<span class="badge bg-danger">
                                  Reject
                                </span>`;
        }

        return `${requSts}`;
      },
    },
    {
      title: "Work Status",
      data: "status_new",
      render: (data, type, row) => {
        let requSts = "";
        if (data === "1") {
          requSts = `<span class="badge bg-success">
                                  Publish
                                </span>`;
        } else {
          requSts = `<span class="badge bg-danger">
                                  UnPublish
                                </span>`;
        }

        return `${requSts}`;
      },
    },

    {
      title: "Action",
      data: "id",
      createdCell: (td, cellData, rowData) => {
        // Start with empty HTML
        td.innerHTML = "";

        // Edit Button
        const editBtn = document.createElement("button");
        editBtn.className = "newspaperEditbtn me-1";
        editBtn.title = "Edit";
        editBtn.innerHTML = `<i class="fa fa-pencil-square-o" aria-hidden="true"></i>`;
        editBtn.onclick = () => {
          navigate(`/news-paper-schedule-edit/${rowData.id}`);
        };
        td.appendChild(editBtn);

        // View Button
        const viewBtn = document.createElement("button");
        viewBtn.className = "newspaperviewbtn me-1";
        viewBtn.title = "View";
        viewBtn.innerHTML = `<i class="fa fa-eye" aria-hidden="true"></i>`;
        viewBtn.onclick = () => {
          navigate(`/news-paper-schedule-view/${rowData.id}`);
        };
        td.appendChild(viewBtn);

        // Conditionally show Update Button only if vender_status === "1"
        if (rowData.vender_status === "1") {
          const updateBtn = document.createElement("button");
          updateBtn.className = "newspaperupdbtn";
          updateBtn.title = "Update";
          updateBtn.innerHTML = `<i class="fa fa-paper-plane" aria-hidden="true"></i>`;
          updateBtn.onclick = () => {
            navigate(`/news-schedule-update/${rowData.id}`);
          };
          td.appendChild(updateBtn);
        }
      },
    },
  ];

  useEffect(() => {
    const handleSelectAll = function () {
      const isChecked = $(this).is(":checked");
      $(".row-checkbox").prop("checked", isChecked);
    };
    const handleRowCheckbox = function () {
      const allChecked =
        $(".row-checkbox").length === $(".row-checkbox:checked").length;
      $("#selectAll").prop("checked", allChecked);
    };

    // Handle row click navigation

    // Handle Update button click
    const handleStatusChange = async function (e) {
      e.preventDefault();

      const selectedIDs = $(".row-checkbox:checked")
        .map(function () {
          return $(this).data("id");
        })
        .get();

      const actionValue = $(".publishstatusSelect").val();

      if (!actionValue) {
        alert("Please select Publish/Unpublish Status");
        return;
      }

      if (selectedIDs.length === 0) {
        alert("Please select at least one row");
        return;
      }

      const confirmUpdate = window.confirm(
        `Are you sure you want to ${
          actionValue === "1" ? "Publish" : "Unpublish"
        } ${selectedIDs.length} selected newspaper(s)?`
      );

      if (!confirmUpdate) return;

      const fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("vendor_status", actionValue);
      fdata.append("news_id", selectedIDs);

      try {
        const { data } = await axios.post(
          `${WebsiteAPIurl}vendormultiNewsUpdate`,
          fdata,
          {
            headers: {
              Authorization: RendomTokenfetch,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (data.Status === "0") {
          NotifyMessageNoReload(data.message, "danger", true);
        } else if (data.Status === "1") {
          NotifyMessageNoReload(data.message, "success", true);
          $(".row-checkbox, #selectAll").prop("checked", false);
          $(".publishstatusSelect").val("");

          navigate(`/news-paper-schedule`);
        }
      } catch (error) {
        console.error(error);
        alert("Something went wrong while updating.");
      }
    };

    $(document).on("change", "#selectAll", handleSelectAll);
    $(document).on("change", ".row-checkbox", handleRowCheckbox);
    $(document).on("click", ".publishstatusbtn", handleStatusChange);

    return () => {
      $(document).off("click", ".publishstatusbtn", handleStatusChange);
      $(document).off("change", "#selectAll", handleSelectAll);
      $(document).off("change", ".row-checkbox", handleRowCheckbox);
    };
  }, [navigate, userID, RendomTokenfetch, vendorRollID, NewsPaperVendor]);

  if (loading || Filterloading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      {/* *******************Count Total Status************** */}
      <div className="row">
        <div
          className="ui-block col-xl-2 col-lg-3 col-md-6 col-sm-12"
          onClick={() => handleCountBoxClick("vendorWorkstatus", "0")}
        >
          <div className="ui-item ui-red">
            <div className="left">
              <i className="icon fa fa-low-vision"></i>
            </div>
            <div className="right">
              <h4>{StatusNewsCount?.unpublish || 0}</h4>
              <p>UnPublish</p>
            </div>
          </div>
        </div>
        <div
          className="ui-block col-xl-2 col-lg-3 col-md-6 col-sm-12"
          onClick={() => handleCountBoxClick("vendorWorkstatus", "1")}
        >
          <div className="ui-item ui-green">
            <div className="left">
              <i className="icon fa fa-hand-o-up"></i>
            </div>
            <div className="right">
              <h4>{StatusNewsCount?.publish || 0}</h4>
              <p>Publish</p>
            </div>
          </div>
        </div>

        <div
          className="ui-block col-xl-2 col-lg-3 col-md-6 col-sm-12"
          onClick={() => handleCountBoxClick("Requeststatus", "2")}
        >
          <div className="ui-item ui-yellow">
            <div className="left">
              <i className="icon fa fa-share-square-o"></i>
            </div>
            <div className="right">
              <h4>{StatusNewsCount?.pending || 0}</h4>
              <p>Pending</p>
            </div>
          </div>
        </div>
        <div
          className="ui-block col-xl-2 col-lg-3 col-md-6 col-sm-12"
          onClick={() => handleCountBoxClick("Requeststatus", "0")}
        >
          <div className="ui-item ui-red">
            <div className="left">
              <i className="icon fa fa-times"></i>
            </div>
            <div className="right">
              <h4>{StatusNewsCount?.reject || 0}</h4>
              <p>Rejected</p>
            </div>
          </div>
        </div>
        <div
          className="ui-block col-xl-2 col-lg-3 col-md-6 col-sm-12"
          onClick={() => handleCountBoxClick("Requeststatus", "1")}
        >
          <div className="ui-item ui-green">
            <div className="left">
              <i className="icon fa fa-check-square-o"></i>
            </div>
            <div className="right">
              <h4>{StatusNewsCount?.accpet || 0}</h4>
              <p>Accepted</p>
            </div>
          </div>
        </div>
      </div>

      {/* ************Filters Data Rows ************* */}
      <div className="row">
        <div className="col-lg-12">
          <div className="ls-widget">
            <div className="tabs-box">
              <div className="widget-title  px-2 py-1 newsvendorfliderheading">
                <p className="mb-0">FILTER BY</p>
              </div>
              <div className="widget-content p-3">
                <form className="was-validated" onSubmit={handleFilterSubmit}>
                  <div className="row">
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="startDate">Start Date</label>
                      <input
                        type="date"
                        id="startDate"
                        className="form-control"
                        name="startDate"
                        value={tempFilters.startDate}
                        onChange={handleFilterChange}
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="endDate">End Date</label>
                      <input
                        type="date"
                        id="endDate"
                        className="form-control"
                        name="endDate"
                        value={tempFilters.endDate}
                        onChange={handleFilterChange}
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="workStatus">Status</label>
                      <select
                        className=" form-control"
                        id="workStatus"
                        name="workStatus"
                        value={tempFilters.workStatus}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select</option>
                        {vendorStatus.map((val) => (
                          <option value={val.value} key={val.value}>
                            {val.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="vendorWorkstatus">
                        Vendor Work Status
                      </label>
                      <select
                        className=" form-control"
                        id="vendorWorkstatus"
                        name="vendorWorkstatus"
                        value={tempFilters.vendorWorkstatus}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select</option>
                        {vendorworkstatus &&
                          vendorworkstatus.map((valStatus) => (
                            <option value={valStatus.id} key={valStatus.id}>
                              {valStatus.title}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="Requeststatus">
                        Vendor Request Status
                      </label>
                      <select
                        className=" form-control"
                        name="Requeststatus"
                        id="Requeststatus"
                        value={tempFilters.Requeststatus}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select</option>
                        {vendorRequeststatus &&
                          vendorRequeststatus.map((requSts) => (
                            <option value={requSts.id} key={requSts.id}>
                              {requSts.title}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-lg-12 col-md-12 text-center mt-3">
                      <button className="theme-btn btn-style-three submitbtn">
                        Submit
                      </button>
                      <span
                        className="mx-4 theme-btn btn-style-three submitbtn"
                        onClick={newspaperClearFilter}
                      >
                        Clear Filter
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ************Data Table Rows ************* */}
      <div className="row">
        <div className="col-lg-12">
          <div className="ls-widget mb-0">
            <div className="tabs-box">
              <div
                className="widgetcontent p-3 table-responsive"
                style={{ overflowX: "auto" }}
              >
                {/* <div className="newspapermultyupdatebox">
          <form encType="multipart/form-data" className="was-validated">
            <div className="row my-2">
              <div className="form-group col-lg-3 col-md-3 mb-2">
                <select className="publishstatusSelect form-control" required>
                  <option value="">Select</option>
                  <option value="1">Publish</option>
                  <option value="0">Unpublish</option>
                </select>
              </div>
              <div className="col-lg-3 col-md-3 text-center mt-1">
                <button className="theme-btn btn-style-three submitbtn publishstatusbtn">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div> */}
                <DataTable
                  className="table table-striped table-bordered vendordatatable"
                  ref={tableRef}
                  columns={columns}
                  responsive={true}
                  noHeader={true}
                  style={{ tableLayout: "auto", width: "100%" }}
                  processing={true}
                  options={{
                    responsive: false,
                    ordering: false,
                    scrollX: true,
                    dom: "Bfrtip",

                    buttons: [
                      {
                        extend: "copy",
                        text: `<i class="fa fa-clone"></i>`,
                        className: "btn btn-sm",
                        titleAttr: "Copy to clipboard",
                        exportOptions: {
                          columns: ":visible",
                        },
                      },
                      {
                        extend: "excelHtml5",
                        text: `<i class="fa fa-file-excel-o"></i>`,
                        className: "btn btn-sm",
                        titleAttr: "Export to Excel",
                        exportOptions: {
                          columns: ":visible",
                        },
                      },
                      {
                        extend: "pdfHtml5",
                        text: `<i class="fa fa-file-pdf-o"></i>`,
                        className: "btn btn-sm",
                        titleAttr: "Export to PDF",
                        exportOptions: {
                          columns: ":visible",
                        },
                      },
                      {
                        extend: "print",
                        text: '<i class="fa fa-print"></i>',
                        className: "btn btn-sm",
                        titleAttr: "Print table",
                        exportOptions: {
                          columns: ":visible",
                          modifier: {
                            page: "all",
                          },
                        },
                      },
                      {
                        extend: "colvis",
                        text: "Column Visibility", // Boxicon for Column Visibility
                        className: "btn btn-sm",
                        titleAttr: "Toggle column visibility",
                      },
                      {
                        extend: "pageLength",
                        text: "Show Rows",
                        className: "btn btn-sm",
                        titleAttr: "Change Number of Rows Displayed",
                      },
                    ],
                    lengthMenu: [
                      [10, 50, 100, 150, 200, -1],
                      [10, 50, 100, 150, 200, "All"],
                    ],

                    colVis: {
                      restore: true,
                    },

                    stateSave: true,
                    deferRender: true,
                    scrollCollapse: true,
                    scroller: true,
                    pagingType: "full_numbers",
                    fixedHeader: true,
                    autoWidth: false,
                    serverSide: true,
                    paging: true,
                    pageLength: 10,
                    ajax: (data, callback) => {
                      const currentFilters = filtersRef.current;

                      const page = Math.floor(data.start / data.length) + 1;
                      const limit = data.length;

                      axios
                        .get(`${WebsiteAPIurl}getVendorNewsList`, {
                          params: {
                            userid: userID,
                            startdate: currentFilters.startDate,
                            enddate: currentFilters.endDate,
                            workstatus: currentFilters.workStatus,
                            vendorWorkstatus: currentFilters.vendorWorkstatus,
                            Requeststatus: currentFilters.Requeststatus,
                            page: page,
                            limit: limit,
                            search: data.search.value,
                          },
                          headers: { Authorization: RendomTokenfetch },
                        })
                        .then((res) => {
                          const r = res.data;
                          const total = parseInt(r.getallnewscount) || 0;
                          const data = Array.isArray(r.newsdata)
                            ? r.newsdata
                            : [];

                          setNewsPaperVendor(data);
                          setStatusNewsCount(res.data.statuscount);
                          callback({
                            data: r.newsdata,
                            recordsTotal: total,
                            recordsFiltered: total,
                          });
                        })
                        .catch(() =>
                          callback({
                            data: [],
                            recordsTotal: 0,
                            recordsFiltered: 0,
                          })
                        );
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
